import React from 'react';
import PageShell from './PageShell';
import Breadcrumbs from '../Breadcrumbs';
import Contact from '../sections/Contact';
import { usePageMeta } from '../../lib/useMeta';

const PATH = '/contact';

const BREADCRUMBS = [
  { label: 'Home', href: '/' },
  { label: 'Contact & Location' },
];

const ContactPage = () => {
  usePageMeta({
    title: 'Contact & Location | Universal Kempo Karate \u2014 Colorado Springs',
    description:
      'Visit Universal Kempo Karate at 2380 Montebello Dr. W, Colorado Springs, CO 80918. Call (719) 896-0593 to book your free trial karate class.',
    path: PATH,
    breadcrumbs: BREADCRUMBS,
  });
  return (
    <PageShell>
      <Breadcrumbs items={BREADCRUMBS} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pt-6 pb-4">
        <h1 className="font-display font-black tracking-tight text-white text-[2rem] leading-[1.05] sm:text-5xl sm:leading-[1.02]">
          Contact &amp; Location
        </h1>
        <p className="mt-4 text-white/75 text-[15px] sm:text-lg leading-relaxed max-w-3xl">
          Our Revolution location sits in northeast Colorado Springs near Montebello. Free parking
          on site, families welcome to watch any class, and your free trial is just a call away.
        </p>
      </div>
      <Contact />
    </PageShell>
  );
};

export default ContactPage;
